"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_vodafone__store(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "465f7c18-89f0-48c7-9746-239539748ef5",
    "data-name": "Vodafone_shop_ic_mid",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "57badbc2-534f-4788-8828-690eb6ca9936",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: 69.5,
    x2: 46,
    y2: 54,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 69.5,
    x2: 70,
    y2: 54,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 69.5,
    x2: 96,
    y2: 54,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122,
    y1: 69.5,
    x2: 122,
    y2: 54,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146,
    y1: 69.5,
    x2: 146,
    y2: 54,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.45,
    y1: 54,
    x2: 171.65,
    y2: 54,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "b8cc70c3-5d28-4436-87ee-9b052f4098d9",
    "data-name": "<Pfad>",
    d: "M146,69a14.06,14.06,0,0,0,12,7c8.09,0,14.16-6.56,14.16-14.66V58.1l-3.74-32.7a8.73,8.73,0,0,0-8.63-7.4H32.21a8.73,8.73,0,0,0-8.63,7.4L19.95,58.1l0,3.23C19.93,69.43,25.89,76,34,76a14.09,14.09,0,0,0,12-7",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,69a13.79,13.79,0,0,0,24,0",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,69a15.64,15.64,0,0,0,26,.12",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,69.12A14.83,14.83,0,0,0,108.5,76c5.23,0,10.91-2.88,13.5-7",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,69a13.79,13.79,0,0,0,24,0",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 98,
    width: 92,
    height: 76,
    rx: 2,
    ry: 2,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,73.5V170a4,4,0,0,0,4,4H164a2,2,0,0,0,2-2V73.51",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 174,
    x2: 96,
    y2: 98,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106,
    y1: 138,
    x2: 114,
    y2: 138,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 138,
    x2: 86,
    y2: 138,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("title", null, "vodafone-store-mid"), /*#__PURE__*/React.createElement("g", {
    id: "adf3705f-e88e-4646-bdc0-4ea461176e7d",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("use", {
    width: 192,
    height: 192,
    transform: "translate(0 0)",
    xlinkHref: "#465f7c18-89f0-48c7-9746-239539748ef5"
  })));
}

var _default = ic_vodafone__store;
exports.default = _default;